<script setup>

// Imports
import { defineLazyHydrationComponent } from '#imports'

// Props
const props = defineProps({
  block: {
    type: Object,
    default: () => ({})
  }
})

const LazyIndustryShowcase = defineLazyHydrationComponent(
  'visible',
  () => import('./LazyIndustryShowcase.vue')
)

</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
<section class="industry-showcase">
  <div class="container">

    <div class="industry-showcase__head">
      <div class="industry-showcase__head-title"
        v-html="props.block?.['heading']?.html"></div>
      <div class="industry-showcase__head-description"
        v-html="props.block?.['simpleCkeditor']?.html"></div>
    </div>

    <LazyIndustryShowcase
      :items="props.block?.['items']"
      data-hydration="lazy-hydration"
    />
    
  </div>
</section>
</template>

<!-- -------------------------------------------------------------------------------------------------
    Styling
------------------------------------------------------------------------------------------------- -->

<style scoped>

.industry-showcase {
  margin-bottom: 80px;

  @media (min-width: 1024px) {
    margin-bottom: 140px;
  }

  @media (min-width: 1440px) {
    margin-bottom: 160px;
  }
}

.industry-showcase__head {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 33px;

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 16px;
    margin-bottom: 48px;
  }
}

.industry-showcase__head-title {
  @media (min-width: 1024px) {
    width: calc(670 / 1552 * 100%);
    flex-shrink: 0;
  }
}

.industry-showcase__head-description {
  @media (min-width: 1024px) {
    width: calc(866 / 1552 * 100%);
    flex-shrink: 0;
  }

  @media (min-width: 1440px) {
    padding-top: 12px;
  }
}

.industry-showcase__head-title :deep(*) {
  font-size: 28px;
  line-height: 120%; /* 33.6px */
  letter-spacing: -0.56px;

  @media (min-width: 1024px) {
    font-size: 38px;
    line-height: 120%; /* 45.6px */
    letter-spacing: -0.76px;
  }
}

.industry-showcase__head-description :deep(*) {
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.32px;
  color: var(--color-gray-500);

  @media (min-width: 1024px) {
    font-size: 18px;
    line-height: 138%; /* 24.84px */
    letter-spacing: -0.36px;
  }
}

</style>